





export class GxComponent extends HTMLElement {
  constructor() {
    super()
  }
}



if (!window.customElements.get("gx-c")) {
  window.customElements.define("gx-c", GxComponent)
}
